import React, { FC, FormEvent, MouseEvent } from "react";

import { toast } from "react-toastify";

import {
  useInput,
  useApisManagersAiCompanyContextsCreate,
  useBoolean,
  useArray,
  useApisManagersAiCompanyContextsIndex,
  useAiCustomizeSlideNavigation,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import {
  AiCompanyContextForm,
  AiCompanyContextDetails,
} from "~/components/organisms";

import { AiCompanyContextType } from "~/domains";

export const ManagersAiCustomizeCompanyContextsIndex: FC = () => {
  const { items: aiCompanyContexts, setItems: setAiCompanyContexts } =
    useArray<AiCompanyContextType>();

  const { fetchNextPage, refetch, hasNextPage, isFetching } =
    useApisManagersAiCompanyContextsIndex({
      config: {
        onSuccess: (data) => {
          setAiCompanyContexts(
            data.pages.map((page) => page.aiCompanyContexts).flat(),
          );
          const latestContext =
            data.pages[0]?.aiCompanyContexts[0]?.context || "";
          setContext(latestContext);
        },
      },
    });

  const { navigations } = useAiCustomizeSlideNavigation({
    selectedArray: [true, false, false],
  });

  const breadCrumbItems = [
    {
      label: "AIカスタマイズ",
      href: "/managers/ai_costomize/company_contexts",
    },
  ];

  const {
    isChecked: isReadOnly,
    setTrue: setReadonly,
    setFalse: setNotReadonly,
  } = useBoolean(true);
  const [{ value: context, onChange: onChangeContext }, setContext] =
    useInput("");

  const { mutate: postRequest, isLoading: isSubmitting } =
    useApisManagersAiCompanyContextsCreate();

  const handleReadonly = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setReadonly();
  };

  const handleNotReadonly = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setNotReadonly();
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const body = {
      context,
    };

    postRequest(
      { body },
      {
        onSuccess: async (data) => {
          toast(data.message);
          setContext("");
          setReadonly();
          await refetch();
        },
      },
    );
  };

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent
        navigations={navigations}
        withRightSidebar
        className="space-y-6"
      >
        <AiCompanyContextForm
          context={{ value: context, onChange: onChangeContext }}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          handleReadonly={handleReadonly}
          handleNotReadonly={handleNotReadonly}
          isReadOnly={isReadOnly}
        />
        <AiCompanyContextDetails
          aiCompanyContexts={aiCompanyContexts}
          isLoading={isFetching}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          refetch={refetch}
        />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
